/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddAssignmentToPlanRequest } from '../models';
// @ts-ignore
import type { CreateDevelopmentPlanRequest } from '../models';
// @ts-ignore
import type { DevelopmentPlanResponse } from '../models';
// @ts-ignore
import type { PageDevelopmentPlanResponse } from '../models';
// @ts-ignore
import type { Pageable } from '../models';
// @ts-ignore
import type { UpdateDevelopmentPlanRequest } from '../models';
/**
 * DevelopmentPlansApi - axios parameter creator
 * @export
 */
export const DevelopmentPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add assignment to plan
         * @param {number} planId 
         * @param {AddAssignmentToPlanRequest} addAssignmentToPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssignment: async (planId: number, addAssignmentToPlanRequest: AddAssignmentToPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('addAssignment', 'planId', planId)
            // verify required parameter 'addAssignmentToPlanRequest' is not null or undefined
            assertParamExists('addAssignment', 'addAssignmentToPlanRequest', addAssignmentToPlanRequest)
            const localVarPath = `/api/plans/{planId}/assignments`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAssignmentToPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign plan to participant
         * @param {number} planId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToParticipant: async (planId: number, participantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('assignToParticipant', 'planId', planId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('assignToParticipant', 'participantId', participantId)
            const localVarPath = `/api/plans/{planId}/assign`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (participantId !== undefined) {
                localVarQueryParameter['participantId'] = participantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change plan status
         * @param {number} planId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus1: async (planId: number, status: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('changeStatus1', 'planId', planId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changeStatus1', 'status', status)
            const localVarPath = `/api/plans/{planId}/status`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create development plan
         * @param {CreateDevelopmentPlanRequest} createDevelopmentPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create2: async (createDevelopmentPlanRequest: CreateDevelopmentPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDevelopmentPlanRequest' is not null or undefined
            assertParamExists('create2', 'createDevelopmentPlanRequest', createDevelopmentPlanRequest)
            const localVarPath = `/api/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDevelopmentPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete development plan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete2: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete2', 'id', id)
            const localVarPath = `/api/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get development plan by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById2: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findById2', 'id', id)
            const localVarPath = `/api/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get plans by participant
         * @param {number} participantId 
         * @param {Pageable} pageable 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByParticipant: async (participantId: number, pageable: Pageable, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('findByParticipant', 'participantId', participantId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('findByParticipant', 'pageable', pageable)
            const localVarPath = `/api/plans/participant/{participantId}`
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get plans by trainer
         * @param {number} trainerId 
         * @param {Pageable} pageable 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByTrainer: async (trainerId: number, pageable: Pageable, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trainerId' is not null or undefined
            assertParamExists('findByTrainer', 'trainerId', trainerId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('findByTrainer', 'pageable', pageable)
            const localVarPath = `/api/plans/trainer/{trainerId}`
                .replace(`{${"trainerId"}}`, encodeURIComponent(String(trainerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove assignment from plan
         * @param {number} planId 
         * @param {number} planAssignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignment: async (planId: number, planAssignmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('removeAssignment', 'planId', planId)
            // verify required parameter 'planAssignmentId' is not null or undefined
            assertParamExists('removeAssignment', 'planAssignmentId', planAssignmentId)
            const localVarPath = `/api/plans/{planId}/assignments/{planAssignmentId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)))
                .replace(`{${"planAssignmentId"}}`, encodeURIComponent(String(planAssignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update development plan
         * @param {number} id 
         * @param {UpdateDevelopmentPlanRequest} updateDevelopmentPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2: async (id: number, updateDevelopmentPlanRequest: UpdateDevelopmentPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update2', 'id', id)
            // verify required parameter 'updateDevelopmentPlanRequest' is not null or undefined
            assertParamExists('update2', 'updateDevelopmentPlanRequest', updateDevelopmentPlanRequest)
            const localVarPath = `/api/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDevelopmentPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentPlansApi - functional programming interface
 * @export
 */
export const DevelopmentPlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentPlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add assignment to plan
         * @param {number} planId 
         * @param {AddAssignmentToPlanRequest} addAssignmentToPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAssignment(planId: number, addAssignmentToPlanRequest: AddAssignmentToPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAssignment(planId, addAssignmentToPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.addAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign plan to participant
         * @param {number} planId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignToParticipant(planId: number, participantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignToParticipant(planId, participantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.assignToParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change plan status
         * @param {number} planId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeStatus1(planId: number, status: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeStatus1(planId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.changeStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create development plan
         * @param {CreateDevelopmentPlanRequest} createDevelopmentPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create2(createDevelopmentPlanRequest: CreateDevelopmentPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create2(createDevelopmentPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.create2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete development plan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete2(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.delete2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get development plan by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findById2(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findById2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.findById2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get plans by participant
         * @param {number} participantId 
         * @param {Pageable} pageable 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByParticipant(participantId: number, pageable: Pageable, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByParticipant(participantId, pageable, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.findByParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get plans by trainer
         * @param {number} trainerId 
         * @param {Pageable} pageable 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByTrainer(trainerId: number, pageable: Pageable, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByTrainer(trainerId, pageable, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.findByTrainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove assignment from plan
         * @param {number} planId 
         * @param {number} planAssignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAssignment(planId: number, planAssignmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAssignment(planId, planAssignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.removeAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update development plan
         * @param {number} id 
         * @param {UpdateDevelopmentPlanRequest} updateDevelopmentPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update2(id: number, updateDevelopmentPlanRequest: UpdateDevelopmentPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update2(id, updateDevelopmentPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentPlansApi.update2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentPlansApi - factory interface
 * @export
 */
export const DevelopmentPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentPlansApiFp(configuration)
    return {
        /**
         * 
         * @summary Add assignment to plan
         * @param {DevelopmentPlansApiAddAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssignment(requestParameters: DevelopmentPlansApiAddAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.addAssignment(requestParameters.planId, requestParameters.addAssignmentToPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign plan to participant
         * @param {DevelopmentPlansApiAssignToParticipantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToParticipant(requestParameters: DevelopmentPlansApiAssignToParticipantRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.assignToParticipant(requestParameters.planId, requestParameters.participantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change plan status
         * @param {DevelopmentPlansApiChangeStatus1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus1(requestParameters: DevelopmentPlansApiChangeStatus1Request, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.changeStatus1(requestParameters.planId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create development plan
         * @param {DevelopmentPlansApiCreate2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create2(requestParameters: DevelopmentPlansApiCreate2Request, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.create2(requestParameters.createDevelopmentPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete development plan
         * @param {DevelopmentPlansApiDelete2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete2(requestParameters: DevelopmentPlansApiDelete2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.delete2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get development plan by ID
         * @param {DevelopmentPlansApiFindById2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById2(requestParameters: DevelopmentPlansApiFindById2Request, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.findById2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get plans by participant
         * @param {DevelopmentPlansApiFindByParticipantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByParticipant(requestParameters: DevelopmentPlansApiFindByParticipantRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageDevelopmentPlanResponse> {
            return localVarFp.findByParticipant(requestParameters.participantId, requestParameters.pageable, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get plans by trainer
         * @param {DevelopmentPlansApiFindByTrainerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByTrainer(requestParameters: DevelopmentPlansApiFindByTrainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageDevelopmentPlanResponse> {
            return localVarFp.findByTrainer(requestParameters.trainerId, requestParameters.pageable, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove assignment from plan
         * @param {DevelopmentPlansApiRemoveAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignment(requestParameters: DevelopmentPlansApiRemoveAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.removeAssignment(requestParameters.planId, requestParameters.planAssignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update development plan
         * @param {DevelopmentPlansApiUpdate2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2(requestParameters: DevelopmentPlansApiUpdate2Request, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentPlanResponse> {
            return localVarFp.update2(requestParameters.id, requestParameters.updateDevelopmentPlanRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addAssignment operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiAddAssignmentRequest
 */
export interface DevelopmentPlansApiAddAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiAddAssignment
     */
    readonly planId: number

    /**
     * 
     * @type {AddAssignmentToPlanRequest}
     * @memberof DevelopmentPlansApiAddAssignment
     */
    readonly addAssignmentToPlanRequest: AddAssignmentToPlanRequest
}

/**
 * Request parameters for assignToParticipant operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiAssignToParticipantRequest
 */
export interface DevelopmentPlansApiAssignToParticipantRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiAssignToParticipant
     */
    readonly planId: number

    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiAssignToParticipant
     */
    readonly participantId: number
}

/**
 * Request parameters for changeStatus1 operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiChangeStatus1Request
 */
export interface DevelopmentPlansApiChangeStatus1Request {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiChangeStatus1
     */
    readonly planId: number

    /**
     * 
     * @type {string}
     * @memberof DevelopmentPlansApiChangeStatus1
     */
    readonly status: string
}

/**
 * Request parameters for create2 operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiCreate2Request
 */
export interface DevelopmentPlansApiCreate2Request {
    /**
     * 
     * @type {CreateDevelopmentPlanRequest}
     * @memberof DevelopmentPlansApiCreate2
     */
    readonly createDevelopmentPlanRequest: CreateDevelopmentPlanRequest
}

/**
 * Request parameters for delete2 operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiDelete2Request
 */
export interface DevelopmentPlansApiDelete2Request {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiDelete2
     */
    readonly id: number
}

/**
 * Request parameters for findById2 operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiFindById2Request
 */
export interface DevelopmentPlansApiFindById2Request {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiFindById2
     */
    readonly id: number
}

/**
 * Request parameters for findByParticipant operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiFindByParticipantRequest
 */
export interface DevelopmentPlansApiFindByParticipantRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiFindByParticipant
     */
    readonly participantId: number

    /**
     * 
     * @type {Pageable}
     * @memberof DevelopmentPlansApiFindByParticipant
     */
    readonly pageable: Pageable

    /**
     * 
     * @type {string}
     * @memberof DevelopmentPlansApiFindByParticipant
     */
    readonly status?: string
}

/**
 * Request parameters for findByTrainer operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiFindByTrainerRequest
 */
export interface DevelopmentPlansApiFindByTrainerRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiFindByTrainer
     */
    readonly trainerId: number

    /**
     * 
     * @type {Pageable}
     * @memberof DevelopmentPlansApiFindByTrainer
     */
    readonly pageable: Pageable

    /**
     * 
     * @type {string}
     * @memberof DevelopmentPlansApiFindByTrainer
     */
    readonly status?: string
}

/**
 * Request parameters for removeAssignment operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiRemoveAssignmentRequest
 */
export interface DevelopmentPlansApiRemoveAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiRemoveAssignment
     */
    readonly planId: number

    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiRemoveAssignment
     */
    readonly planAssignmentId: number
}

/**
 * Request parameters for update2 operation in DevelopmentPlansApi.
 * @export
 * @interface DevelopmentPlansApiUpdate2Request
 */
export interface DevelopmentPlansApiUpdate2Request {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentPlansApiUpdate2
     */
    readonly id: number

    /**
     * 
     * @type {UpdateDevelopmentPlanRequest}
     * @memberof DevelopmentPlansApiUpdate2
     */
    readonly updateDevelopmentPlanRequest: UpdateDevelopmentPlanRequest
}

/**
 * DevelopmentPlansApi - object-oriented interface
 * @export
 * @class DevelopmentPlansApi
 * @extends {BaseAPI}
 */
export class DevelopmentPlansApi extends BaseAPI {
    /**
     * 
     * @summary Add assignment to plan
     * @param {DevelopmentPlansApiAddAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public addAssignment(requestParameters: DevelopmentPlansApiAddAssignmentRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).addAssignment(requestParameters.planId, requestParameters.addAssignmentToPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign plan to participant
     * @param {DevelopmentPlansApiAssignToParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public assignToParticipant(requestParameters: DevelopmentPlansApiAssignToParticipantRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).assignToParticipant(requestParameters.planId, requestParameters.participantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change plan status
     * @param {DevelopmentPlansApiChangeStatus1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public changeStatus1(requestParameters: DevelopmentPlansApiChangeStatus1Request, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).changeStatus1(requestParameters.planId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create development plan
     * @param {DevelopmentPlansApiCreate2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public create2(requestParameters: DevelopmentPlansApiCreate2Request, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).create2(requestParameters.createDevelopmentPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete development plan
     * @param {DevelopmentPlansApiDelete2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public delete2(requestParameters: DevelopmentPlansApiDelete2Request, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).delete2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get development plan by ID
     * @param {DevelopmentPlansApiFindById2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public findById2(requestParameters: DevelopmentPlansApiFindById2Request, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).findById2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get plans by participant
     * @param {DevelopmentPlansApiFindByParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public findByParticipant(requestParameters: DevelopmentPlansApiFindByParticipantRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).findByParticipant(requestParameters.participantId, requestParameters.pageable, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get plans by trainer
     * @param {DevelopmentPlansApiFindByTrainerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public findByTrainer(requestParameters: DevelopmentPlansApiFindByTrainerRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).findByTrainer(requestParameters.trainerId, requestParameters.pageable, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove assignment from plan
     * @param {DevelopmentPlansApiRemoveAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public removeAssignment(requestParameters: DevelopmentPlansApiRemoveAssignmentRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).removeAssignment(requestParameters.planId, requestParameters.planAssignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update development plan
     * @param {DevelopmentPlansApiUpdate2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentPlansApi
     */
    public update2(requestParameters: DevelopmentPlansApiUpdate2Request, options?: RawAxiosRequestConfig) {
        return DevelopmentPlansApiFp(this.configuration).update2(requestParameters.id, requestParameters.updateDevelopmentPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

